import styled from 'styled-components'

export const Wrapper = styled.section`
  &.pageTitle{
    margin: 0 auto;
  }

  &.carousel-wrapper {
    padding: 0;
  }

  margin: 0 auto 10rem auto;
  width: 100%;
  max-width: ${props => props.theme.sizes.maxWidth};
  padding: 0 2rem;
  flex-grow: 1;

  ${props =>
    props.flex &&
    `
    display: flex;
    justify-content: space-between;
    flex-flow: row wrap;
  `}

  @media screen and (min-width: ${props => props.theme.responsive.large}) {
    padding: 0;
  }
`

export const FullWidthWrapper = styled.section`
  margin: 0 auto 8rem auto;
  width: 100%;
  padding: 3em 2em 2em;
  flex-grow: 1;

  &.whiteBg {
    background-color: ${props => props.theme.colors.white};
  }

  &.tabContainer {
    margin-bottom: 0 !important;
    padding-bottom: 3rem;

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      padding-bottom: 7rem;
    }
  }
`

export const Container = styled.div`
  margin: 0 auto auto;
  width: 100%;
  max-width: ${props => props.theme.sizes.maxWidth};
  flex-grow: 1;
`
